var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ApplicationIntro',{staticClass:"bg-white",attrs:{"currentStep":1,"currentStepStartHandler":_vm.goToLogin,"overrideSteps":_vm.overrideSteps,"title":"Getting started with Bungalow","subtitle":"Join the community where everyone can truly feel at home and live wherever they want to live","blurFutureSteps":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }